export default "__VITE_ASSET__DHeVLE3X__"